function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = privateMap.get(receiver); if (!descriptor) { throw new TypeError("attempted to set private field on non-instance"); } if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } return value; }

function _classPrivateFieldGet(receiver, privateMap) { var descriptor = privateMap.get(receiver); if (!descriptor) { throw new TypeError("attempted to get private field on non-instance"); } if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }

var _sorted = new WeakMap();

var _comparator = new WeakMap();

var _sort = new WeakMap();

export class PQueue {
  constructor(comparator) {
    _defineProperty(this, "contents", []);

    _sorted.set(this, {
      writable: true,
      value: false
    });

    _comparator.set(this, {
      writable: true,
      value: void 0
    });

    _sort.set(this, {
      writable: true,
      value: () => {
        if (!_classPrivateFieldGet(this, _sorted)) {
          this.contents.sort(_classPrivateFieldGet(this, _comparator));

          _classPrivateFieldSet(this, _sorted, true);
        }
      }
    });

    _classPrivateFieldSet(this, _comparator, comparator);
  }

  push(item) {
    this.contents.push(item);

    _classPrivateFieldSet(this, _sorted, false);
  }

  peek(index) {
    _classPrivateFieldGet(this, _sort).call(this);

    return this.contents[typeof index === `number` ? index : this.contents.length - 1];
  }

  pop() {
    _classPrivateFieldGet(this, _sort).call(this);

    return this.contents.pop();
  }

  size() {
    return this.contents.length;
  }

  map(mapper) {
    _classPrivateFieldGet(this, _sort).call(this);

    return this.contents.map(mapper);
  }

}